import { createSetting } from '@shopex/finder'
import { useDialog } from '@shopex/finder'
// import { stop } from '../api'
import { MessageBox } from 'element-ui'
import PiiInfo from '@/components/piiInfo/index'


export const ITEM_STATUS_OPTIONS = [
  { label: '实物礼品', value: 'physical' },
  { label: '红包封面', value: 'redpacket_cover' },
  { label: '表情包', value: 'emoji' },
  { label: '手机壁纸', value: 'wallpaper' },
  { label: '积分', value: 'points' },
]


export const tableSetting = (vm) => createSetting({
  search: [
    {
      name: '',
      key: 'keyword',
      placeholder: '奖品名称/奖品编号'
    },
    {
      name: '',
      key: 'gift_type',
      type: 'select',
      options: ITEM_STATUS_OPTIONS,
      clearable: true,
      placeholder: '请选择礼品类型'
    },
    {
      name: '',
      key: 'pullTime',
      type: 'date-time-picker',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间'
    }
  ],
  columns: [
    {
      name: '中奖ID',
      key: 'id',
      width: 90
    },
    {
      name: '奖品编号',
      key: 'winning_code',
      minWidth: 150
    },
    {
      name: '奖品类型',
      key: 'gift_type_cn',
      minWidth: 100,
    },
    {
      name: '奖品名称',
      key: 'gift_name',
      minWidth: 100,
    },
    {
      name: '奖品编码',
      key: 'gift_code',
      minWidth: 100,
    },
    {
      name: '收货信息',
      key: 'receiver_info',
      minWidth: 150,
      render: (h, {row}) =>{
        if(row.receiver_name){
          return(
            <div>
              <span style="margin-right: 8px;">{row.receiver_name} {row.receiver_mobile}</span>
              <PiiInfo pageType='12' memberType='' optionScene='cny_address' associatedId={String(row.id)} forceShow={true} />
            </div>
          )
        }else{
          return '-'
        }
      },
    },
    {
      name: '物流信息',
      key: 'express_company',
      minWidth: 100,
      render: (h, {row}) =>{
        if(row.express_company && row.express_tracking_number){
          return `${row.express_company} ${row.express_tracking_number}`
        }else{
          return '-'
        }
      },
    },
    {
      name: '中奖时间',
      key: 'lottery_time_format',
      minWidth: 180,
      // render: (h, { row }) => {
      //   const start = vm.$options.filters['datetime'].call(vm, new Date(parseInt(row.lottery_time_format)), 'yyyy-MM-dd hh:mm:ss' )
      //   return `${start}`
      // }
    }
  ],
  actions: [
    {
      name: '导出中奖记录',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: () => {
          vm.handleExport()
        }
      }
    },  {
      name:'填写物流',
      type:'button',
      buttonType:'text',
      visible: (row) => {
        return row.can_fill_express
      },
      action: {
        handler:(row) =>  {
          vm.handleFillLogistics(row[0])
        }
      }
    }
  ]
})
